import { useTranslation } from 'react-i18next'
import Tooltip from '@mui/material/Tooltip'
import Box from '@mui/material/Box'

import {
  toggleFilterByEmailDialog as openFilterByEmailModal,
  toggleFilterByScreenNameDialog as openFilterByScreenNameModal,
  addFilter,
} from 'redux/slices/FilterBuilder'
import { useAppSelector, useAppDispatch } from 'redux/Hook'
import { FilterItem } from 'types/FilterBuilder'
import { getMenuItem } from 'components/Shared/FilterBuilder/HelperFilterMenu'
import { toggleModal as openSignUpQuestionsModal } from 'redux/slices/SignUpQuestions'
import { AllAdmins } from 'lib/authorization/Roles'

type Props = {
  handleClose: () => void
  filters: FilterItem[]
}

const MODAL_FILTERS = ['signUpQuestion', 'email', 'screenName']

const FilterMenus = (props: Props) => {
  const { handleClose, filters } = props
  const { roleName } = useAppSelector((state) => state.user.user)
  const selectedFilters = useAppSelector(
    (state) => state.filterBuilder.selectedFilters,
  )
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const handleModalFiltersClick = (filterName: string) => {
    switch (filterName) {
      case 'signUpQuestion':
        dispatch(openSignUpQuestionsModal())
        break
      case 'email':
        dispatch(openFilterByEmailModal())
        break
      case 'screenName':
        dispatch(openFilterByScreenNameModal())
    }

    handleClose()
  }

  const handleMenuClick = (filter: FilterItem) => {
    if (MODAL_FILTERS.includes(filter.name as string)) {
      handleModalFiltersClick(filter.name as string)

      return
    }

    if (filter.disabled) return

    const selectedFilter = { ...filter, disabled: true, isDefault: true }

    dispatch(addFilter(selectedFilter))
    handleClose()
  }

  const isMenuPermitted = (allowedTo: string[]) => {
    return allowedTo.includes(AllAdmins) || allowedTo.includes(roleName)
  }

  const checkIfDisabled = (currentItem: FilterItem) => {
    if (currentItem.disabled) return true // For primary filters

    // For filters selected from list
    const itemFromStore = selectedFilters.find(
      (fItem: FilterItem) => fItem.name === currentItem.name,
    )

    if (itemFromStore?.disabled) return true

    // For filters with conditional disabling
    const filterToBeDisabled = selectedFilters.find(
      (item: FilterItem) =>
        currentItem.name &&
        item.conditionToDisable &&
        item.conditionToDisable.includes(currentItem.name),
    )
    if (filterToBeDisabled) return true

    return false
  }

  const renderOptions = () => {
    return filters.map((item: any, index: number) => {
      if (item.hidden) return
      const { allowedTo, toolTipText } = item
      const isDisabled = checkIfDisabled(item)
      const isPermitted = allowedTo && isMenuPermitted(allowedTo)
      if (!isPermitted) return

      if (toolTipText) {
        return (
          <Tooltip
            placement="right-end"
            title={<>{t?.(toolTipText)}</>}
            arrow
            key={index}
          >
            <Box>
              {getMenuItem({ item, index, isDisabled, handleMenuClick })}
            </Box>
          </Tooltip>
        )
      }

      return getMenuItem({ item, index, isDisabled, handleMenuClick })
    })
  }

  return <>{renderOptions()}</>
}

export default FilterMenus
